module.exports = __webpack_public_path__ + "static/media/gym_master.e7a48a68.png";